import api from '@/api';

const state = () => ({
  ossBeaseOptions:{}, //v3 oss参数
  nonChrome:(!(navigator.userAgent.indexOf('Chrome') > -1)||(navigator.userAgent.indexOf('Edge') > -1))&&!localStorage.getItem("close-hint")//非谷歌浏览器提示
})

const getters = {
  
}

const mutations = {
  //更新oss参数
  setOssBeaseOptions(state, data) {
    state.ossBeaseOptions = data;
  },
  //关闭非Chrome浏览器提示。并且向本地缓存中加入数据
  setNonChrome(state){
    localStorage.setItem("close-hint","close")
    state.nonChrome = false
  }
}

const actions = {
  //获取oss，bease64接口参数
  getOssBeaseOptions: async ({ dispatch, state, commit }, cvDetail)=>{
    api.staticApi.get_oss_token({}).then(res => {
      if (res.code === 1000) {
        let { access_key_id, access_key_secret, bucket_name, region, security_token,endpoint } = res.data;
        let ossBeaseOptions = {
          region: region,
          accessKeyId: access_key_id,
          accessKeySecret: access_key_secret,
          bucket: bucket_name,
          endpoint:endpoint,
          stsToken: security_token
        };
        commit('setOssBeaseOptions', ossBeaseOptions);
      } else {
  
      }
    })
  }
}


export default {
  namespaced: true,
  actions,
  mutations,
  getters,
  state
}